import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CONSTRUCTION_ACTION_TYPE = createNamedActions('construction', {
  GET_BUDGET: 'GET_BUDGET',
  SAVE_BUDGET: 'SAVE_BUDGET',
  GET_DRAW_REQUESTS: 'GET_DRAW_REQUESTS',
  CREATE_DRAW_REQUEST: 'CREATE_DRAW_REQUEST',
  DECIDE_DRAW_REQUEST: 'DECIDE_DRAW_REQUEST',
  CLEAR: 'CLEAR',
});

export const DrawRequestStatus = {
  SUBMITTED: 'Submitted',
  UNDER_REVIEW: 'UnderReview',
  INSPECTION: 'Inspection',
  APPROVED: 'Approved',
  DISBURSED: 'Disbursed',
  REJECTED: 'Rejected',
};

export const DrawInspectionStatus = {
  NOT_ORDERED: 'NotOrdered',
  ORDERED: 'Ordered',
  SCHEDULED: 'Scheduled',
  PASSED: 'Passed',
  FAILED: 'Failed',
};

export const DrawReviewDecision = {
  APPROVE: 'Approve',
  DENY: 'Deny',
  REQUEST_CHANGES: 'RequestChanges',
};

const ConstructionBudgetCategory = {
  SITE_PREPARATION: 'SitePreparation',
  FOUNDATION: 'Foundation',
  FRAMING: 'Framing',
  ROOFING: 'Roofing',
  MECHANICAL_ELECTRICAL_PLUMBING: 'MechanicalElectricalPlumbing',
  INTERIOR: 'Interior',
  EXTERIOR: 'Exterior',
  LANDSCAPING: 'Landscaping',
  PERMITS: 'Permits',
  CONTINGENCY: 'Contingency',
  OTHER: 'Other',
};

// The API serializes ConstructionBudgetStatus/ConstructionType as the enum NAME (e.g. "Active",
// "GroundUp"), so the create-budget payload uses these string constants.
export const ConstructionBudgetStatus = {
  DRAFT: 'Draft',
  ACTIVE: 'Active',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
};

export const ConstructionType = {
  GROUND_UP: 'GroundUp',
  RENOVATION: 'Renovation',
  LOT: 'Lot',
};

// The Loans API serializes a budget line's category as the raw enum name (e.g. MechanicalElectricalPlumbing),
// which is not display-ready. The cost-code column, budget editor, and draw-review line items all read the
// mapped costCode, so the mapper resolves the category to this human-readable label once.
export const CONSTRUCTION_BUDGET_CATEGORY_LABEL = {
  [ConstructionBudgetCategory.SITE_PREPARATION]: 'Site Preparation',
  [ConstructionBudgetCategory.FOUNDATION]: 'Foundation',
  [ConstructionBudgetCategory.FRAMING]: 'Framing',
  [ConstructionBudgetCategory.ROOFING]: 'Roofing',
  [ConstructionBudgetCategory.MECHANICAL_ELECTRICAL_PLUMBING]: 'Mechanical, Electrical & Plumbing',
  [ConstructionBudgetCategory.INTERIOR]: 'Interior',
  [ConstructionBudgetCategory.EXTERIOR]: 'Exterior',
  [ConstructionBudgetCategory.LANDSCAPING]: 'Landscaping',
  [ConstructionBudgetCategory.PERMITS]: 'Permits',
  [ConstructionBudgetCategory.CONTINGENCY]: 'Contingency',
  [ConstructionBudgetCategory.OTHER]: 'Other',
};

const CONSTRUCTION_TYPE_LABEL = {
  [ConstructionType.GROUND_UP]: 'Ground-Up Construction',
  [ConstructionType.RENOVATION]: 'Renovation',
  [ConstructionType.LOT]: 'Lot / Land',
};

// Picker options for the create-budget form ({ id, name } so AutocompleteCDS can key on id and label
// on name). The category order follows the natural build sequence used across the construction UI.
export const CONSTRUCTION_BUDGET_CATEGORY_OPTIONS = Object.values(ConstructionBudgetCategory).map(
  category => ({ id: category, name: CONSTRUCTION_BUDGET_CATEGORY_LABEL[category] }),
);

export const CONSTRUCTION_TYPE_OPTIONS = Object.values(ConstructionType).map(constructionType => ({
  id: constructionType,
  name: CONSTRUCTION_TYPE_LABEL[constructionType],
}));
